import { render, staticRenderFns } from "./TableServerSideV1Widget.vue?vue&type=template&id=21843af3&"
import script from "./TableServerSideV1Widget.vue?vue&type=script&lang=js&"
export * from "./TableServerSideV1Widget.vue?vue&type=script&lang=js&"
import style0 from "./TableServerSideV1Widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports